module.exports = require('./helpers/bundle-url').getBundleURL('drLhz') + "../assets/images/en.ac1446e4.png";